// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"59fc0261","732":"71e1c5bd","977":"d452f4d5"}[chunkId] + ".chunk.js";
};